export const normalizeStringLength = (str: string, num: number) => {
  if (str.length < num) {
    return str;
  }
  return `${str.slice(0, num - 2)}..`;
};

const toCamelCase = (str: string) => {
  return str.replace(/_([a-z])/g, (match) => match[1].toUpperCase());
};

export const transformKeysFromSnakeCaseToCamelCase = (obj: any): any => {
  if (Array.isArray(obj)) {
    return obj.map(v => transformKeysFromSnakeCaseToCamelCase(v));
  } else if (obj !== null && obj.constructor === Object) {
    return Object.keys(obj).reduce((result: any, key: string) => {
      const camelCaseKey = toCamelCase(key);
      result[camelCaseKey] = transformKeysFromSnakeCaseToCamelCase(obj[key]);
      return result;
    }, {});
  }
  return obj;
};

export const isValidUrl = (url: string) =>
  /^(http:\/\/|https:\/\/)(localhost|\d{1,3}(\.\d{1,3}){3}|([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})(:\d+)?(\/[^\s]*)?$/.test(url);